import type { ComponentProps } from "react";
import { Tooltip as MuiTooltip } from "@material-ui/core";
import styled from "styled-components";

type MuiTooltipProps = ComponentProps<typeof MuiTooltip>;

const TooltipRoot = styled(
  ({ className, classes, ...props }: MuiTooltipProps & { className?: string }) => (
    <MuiTooltip
      {...props}
      classes={{
        ...(classes || {}),
        ...(className ? { popper: className } : {}),
      }}
    />
  ),
)`
  .MuiTooltip-tooltip {
    background: #ffffff;
    color: #5e5e60;
    border: 1px solid #e7e8ec;
    border-radius: 8px;
    box-shadow: 0 6px 18px rgba(17, 18, 25, 0.12);
    padding: 8px 12px;
    font-size: 13px;
    line-height: 1.4;
    font-weight: 400;
    font-family: "Noto Sans", sans-serif;
    max-width: 320px;
  }

  .MuiTooltip-arrow {
    color: #ffffff;

    &::before {
      border: 1px solid #e7e8ec;
    }
  }
`;

const Tooltip = (props: MuiTooltipProps) => <TooltipRoot {...props} />;

export default Tooltip;
